import React from 'react'
import './SearchPage.css'
import { TuneOutlined } from '@mui/icons-material'
import ChannelRow from './ChannelRow'
import VideoRow from './VideoRow'

function SearchPage() {
  return (
    <div className="SearchPage">
      <div className="SearchPage__filter">
        <TuneOutlined />
        <h2>FILTER</h2>
      </div>
      <hr />

      <ChannelRow
        image="https://avatars.githubusercontent.com/u/52933537?v=4"
        channel="Kunmi Talks"
        verified
        subs="1M"
        noOfVideos="240"
        description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias in tempore iste voluptate, ipsum laudantium explicabo eligendi, ex dolorum sed nesciunt molestiae dolore aspernatur porro delectus quod asperiores, laborum deserunt
      Repellendus aut commodi deleniti accusamus blanditiis possimus."
      />

      <hr />

      <VideoRow
        views="1.4M"
        subs="600K"
        description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias in tempore iste voluptate, ipsum laudantium explicabo eligendi, ex dolorum sed nesciunt molestiae dolore "
        timestamp="2 Minute ago"
        channel="Kunmi Talks"
        title="Let Talk"
        image="https://media.istockphoto.com/id/1269144964/photo/handwriting-text-writing-lets-talk-on-notebook.jpg?s=612x612&w=0&k=20&c=rTgN9CcODqDDyhvS0bIfsENloHS10jnOFQN27iZj0Bk="
      />
      <VideoRow
        views="1.4M"
        subs="600K"
        description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias in tempore iste voluptate, ipsum laudantium explicabo eligendi, ex dolorum sed nesciunt molestiae dolore "
        timestamp="2 Minute ago"
        channel="Kunmi Talks"
        title="New Year Goals"
        image="https://media.istockphoto.com/id/1087856726/photo/new-year-fresh-start-on-small-paper-on-wooden-table.jpg?s=612x612&w=0&k=20&c=agl9gKzCUZZPTRZZCH338KvEXNmKPqkpDarKUH-x4Ww="
      />
      <VideoRow
        views="1.4M"
        subs="600K"
        description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias in tempore iste voluptate, ipsum laudantium explicabo eligendi, ex dolorum sed nesciunt molestiae dolore "
        timestamp="2 Minute ago"
        channel="Kunmi Talks"
        title="How Apology works"
        image="https://media.istockphoto.com/id/1081346386/photo/im-sorry-text-concept-write-on-paper.jpg?s=612x612&w=0&k=20&c=YcdNqJ14afPvfHqxIb0ve-b79Q7DB-JbKgpy-WR8eJg="
      />
      <VideoRow
        views="1.4M"
        subs="600K"
        description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias in tempore iste voluptate, ipsum laudantium explicabo eligendi, ex dolorum sed nesciunt molestiae dolore "
        timestamp="2 Minute ago"
        channel="Kunmi Talks"
        title="Routines"
        image="https://media.istockphoto.com/id/1427677570/photo/modern-workplace-with-cup-of-coffee-on-wooden-table.jpg?s=612x612&w=0&k=20&c=Pgf1MBoTVEnK-6XP-Aw3o2EuUtCQy8Z5MzdN3tZFg6w="
      />
      
    </div>
  )
}

export default SearchPage
